import React, {
  useState
}                          from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  createPush,
  showPush,
}                           from '~/config/routes';
import Request              from '~/providers/Request';
import PushRecord           from '~/records/PushRecord';
import Form                 from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new PushRecord());
  const [ loading, setLoading ] = useState(false);

  async function onSubmit (saveAndContinue){

    let image_id = record.get('image_id') ? record.get('image_id') : null;
    const imageBase64 = record.get('image_base64');
    setLoading(true);
    if(imageBase64){
      try {
        const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}` });
        image_id = result.data.id;
      } catch(e) {console.log(e);}
    }

    const data = record.toParams({image_id});
    Request.post('/admin/push_messages', data, {}, { controller: 'push' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue){
          history.push(createPush.spec);
        } else{
          history.push(showPush.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
